var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQuoteGradientSmall = function SvgQuoteGradientSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.085 0L7.633 10.702c1.783.105 3.252.813 4.406 2.124 1.207 1.26 1.81 2.78 1.81 4.564 0 1.889-.656 3.462-1.967 4.721C10.57 23.372 8.944 24 7.003 24c-1.94 0-3.593-.63-4.957-1.889C.682 20.852 0 19.148 0 16.997c0-1.154.289-2.44.866-3.856S2.36 10.046 3.62 8.105C4.93 6.11 6.61 3.698 8.656.865L9.206 0h4.88zM31.24 0l-6.53 10.702c1.835.105 3.33.813 4.484 2.124 1.154 1.26 1.732 2.78 1.732 4.564 0 1.889-.656 3.462-1.968 4.721-1.259 1.26-2.859 1.889-4.8 1.889-1.993 0-3.672-.63-5.036-1.889-1.311-1.259-1.967-2.963-1.967-5.114 0-1.154.289-2.44.866-3.856s1.495-3.095 2.754-5.036c1.259-1.994 2.911-4.407 4.957-7.24l.63-.865h4.878z",
    fill: "url(#quoteGradientSmall_svg__paint0_linear_11404_37116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quoteGradientSmall_svg__paint0_linear_11404_37116",
    x1: 15.62,
    y1: 0,
    x2: 15.62,
    y2: 29.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05",
    stopOpacity: 0.4
  })))));
};
export default SvgQuoteGradientSmall;